import React from "react";
import {
  Button,
  PageTitle,
  PageWrapperTwoColumn,
  Section,
} from "@cinesys/ui/components";
import JobList from "./JobList";
import { Route, Routes } from "react-router-dom";
import { JobViewParams } from "./JobView";
import { useMutation } from "react-query";
import ApiService from "../../services/ApiService";
import { Play } from "react-feather";

const JobListScreen = (props: {
  dlq?: boolean;
  error?: boolean;
  warning?: boolean;
  title?: string;
}) => {
  const { dlq, title, error, warning } = props;

  const dlqRedriveMutation = useMutation({
    mutationFn: async () => {
      await ApiService.fetch("POST", `/api/script_execution/dlq/redrive`);
    },
  });

  return (
    <>
      <PageTitle
        title={title}
        error={
          dlq && dlqRedriveMutation.isError
            ? "Failed to start redrive"
            : undefined
        }
        success={
          dlq && dlqRedriveMutation.isSuccess ? "Redrive started" : undefined
        }
      >
        {dlq && (
          <Button
            icon={Play}
            label="Redrive"
            onClick={() => dlqRedriveMutation.mutate()}
            type="success"
            loading={dlqRedriveMutation.isLoading}
          />
        )}
      </PageTitle>
      <PageWrapperTwoColumn minWidth="1030px">
        <Section>
          <JobList showOrganization dlq={dlq} error={error} warning={warning} />
        </Section>
        <Routes>
          <Route
            path=":systemDomainId/:instanceId/:jobId"
            element={<JobViewParams />}
          />
        </Routes>
      </PageWrapperTwoColumn>
    </>
  );
};

export default JobListScreen;
